import React from 'react';
import CellValueHighlighter from './CellValueHighlighter';

const CellValue = ({ cellData, columnConfig, rowData }) => {
  // 1. Custom Cell Value
  if (columnConfig.CellValue) {
    const CustomCellValue = columnConfig.CellValue;
    return (
      <CustomCellValue
        column={columnConfig}
        rowData={rowData}
        cellValue={cellData}
      />
    );
  }

  // 2. Searchable
  if (columnConfig.searchable) {
    return <CellValueHighlighter cellValue={cellData} />;
  }

  // 3. Non-searchable
  return cellData;
};

export default CellValue;
